import React from 'react';
import colors from '../../../util/colors';

import {Row} from '../../layout';
import './styles.scss';

function HomepageDivider() {
  return (
    <Row className="homepage-shape-divider-row">
      <svg
        width="3800px"
        height="142.5px"
        viewBox="0 0 1440 71"
        version="1.1"
        className="shape-divider-homepage">
        <g
          id="01---Registo"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd">
          <g id="00_00_login" transform="translate(0.000000, -773.000000)">
            <g id="Footer" transform="translate(0.000000, 773.000000)">
              <path
                d="M406.01237,48.0312254 C328.972202,57.6493336 170.007886,66.269594 86.1956087,70.681982 C84.8207732,70.7543617 56.0889036,70.8603677 0,71 L0,0 L1440,0 L1440,69.5115328 C1384.27046,69.3635863 1355.80771,69.2517126 1354.61174,69.1759119 C1280.3576,64.4696864 1209.73229,56.6511998 1140.5963,48.0312254 C1028.98334,34.1155706 877.330515,26.0546147 733.377666,26.0546147 C589.424817,26.0546147 517.771994,34.1155706 406.01237,48.0312254 Z"
                id="Wave-background"
                fill={colors.white}
                fillRule="nonzero"
                transform="translate(720.000000, 35.500000) scale(1, -1) translate(-720.000000, -35.500000) "></path>
              <g
                id="Footer-menu"
                transform="translate(209.000000, 5.000000)"></g>
            </g>
          </g>
        </g>
      </svg>
    </Row>
  );
}

export default HomepageDivider;
